import { Box, Button, TextField } from "@mui/material";
import React from "react";
import { ActivityLogContext } from "../context/activityLogContext";

const ActivityLogSearch = (): React.JSX.Element => {
  const { filter, updateFilter, search, loading } =
    React.useContext(ActivityLogContext);

  return (
    <Box
      component="form"
      onSubmit={(event: React.FormEvent) => {
        event.preventDefault();
        search();
      }}
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr auto" },
        alignItems: "stretch",
        mb: 2,
      }}
    >
      <TextField
        id="activity-log-start"
        type="date"
        label="Von"
        value={filter.start}
        onChange={(event) => updateFilter({ start: event.target.value })}
        disabled={loading}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        id="activity-log-end"
        type="date"
        label="Bis"
        value={filter.end}
        onChange={(event) => updateFilter({ end: event.target.value })}
        disabled={loading}
        InputLabelProps={{ shrink: true }}
      />
      <Button type="submit" variant="contained" size="large" disabled={loading}>
        Suchen
      </Button>
    </Box>
  );
};

export default ActivityLogSearch;
